import {replace, update} from 'utils/history';

export const UNHANDLED_ERROR = 'UNHANDLED_ERROR';
export const LOCATION_REPLACE = 'LOCATION_REPLACE';
export const LOCATION_UPDATE = 'LOCATION_UPDATE';
export const PUBLISHED = 'PUBLISHED';
export const JOBS_JOIN_TOPIC = 'JOBS_JOIN_TOPIC';
export const JOBS_TOPIC_STATE = 'JOBS_TOPIC_STATE';

export function unhandledError(error) {
  return (dispatch) => {
    dispatch({
      type: UNHANDLED_ERROR,
      error,
    });
  };
}

export function locationReplace(params = {}) {
  return (dispatch) => {
    replace(params);

    dispatch({
      type: LOCATION_REPLACE,
      pathname: params.pathname,
      query: params.query,
    });
  };
}

export function locationUpdate(params = {}) {
  return (dispatch) => {
    update(params);

    dispatch({
      type: LOCATION_UPDATE,
      pathname: params.pathname,
      query: params.query,
    });
  };
}

export function published(kitToken) {
  return (dispatch) => {
    dispatch({
      type: PUBLISHED,
      kitToken,
    });
  };
}

export function joinJobStatusTopics(jobStatusTopics) {
  return (dispatch) => {
    dispatch({
      type: JOBS_JOIN_TOPIC,
      jobStatusTopics,
    });
  }
};

export function updateJobStatusTopicState(topic, state) {
  return (dispatch) => {
    dispatch({
      type: JOBS_TOPIC_STATE,
      topic,
      state,
    });
  }
}



// WEBPACK FOOTER //
// ./app/javascript/actions/index.js